// TODO replace this in avg table
export enum GameStatsOption {
    q1 = 'q1',
    q2 = 'q2',
    h1 = 'h1',
    q3 = 'q3',
    q4 = 'q4',
    h2 = 'h2',
    total = 'total'
}
